import { ReturnsAndClaimsPermissions } from "@redotech/account-common/permissions";
import { folderTypes } from "@redotech/redo-model/views/folders";
import { ReturnView } from "@redotech/redo-model/views/views";
import { ReturnTypeEnum } from "@redotech/redo-return-core-common/return-type-enum";
import { ReactNode, createContext, memo } from "react";
import { useViewsAndFolders } from "../hooks/use-views-and-folders";

export const ReturnViewsContext = createContext<
  | {
      teamViews?: ReturnView[];
      folders?: folderTypes["returns"][];
      reloadViews?: () => Promise<void>;
    }
  | undefined
>(undefined);

export const ReloadReturnViewsContext = createContext<
  (() => Promise<void>) | undefined
>(undefined);

export const ReturnViewsProvider = memo(function ReturnViewsProvider({
  children,
}: {
  children: ReactNode | ReactNode[];
}) {
  const { views, folders, reloadViews } = useViewsAndFolders<
    ReturnView,
    folderTypes["returns"],
    ReturnTypeEnum.RETURN
  >(ReturnTypeEnum.RETURN, ReturnsAndClaimsPermissions.VIEW_RETURN);

  return (
    <ReturnViewsContext.Provider
      value={{ teamViews: views, folders, reloadViews }}
    >
      <ReloadReturnViewsContext.Provider value={reloadViews}>
        {children}
      </ReloadReturnViewsContext.Provider>
    </ReturnViewsContext.Provider>
  );
});
